import apiClient from './apiClient';

// Convert '/' to '-' for URL path (e.g., BTC/USD -> BTC-USD), backend converts back
const normalizeSymbolForUrl = (symbol) => symbol?.replace('/', '-') || '';

// Strategy-Symbol Associations API
export const strategySymbolApi = {
  // Activate a strategy for a symbol
  activateStrategy: async (strategyId, symbol, config = {}) => {
    const response = await apiClient.post('/strategy-symbols', {
      strategyId,
      symbol,
      config
    });
    return response.data;
  },

  // Deactivate a strategy for a symbol
  deactivateStrategy: async (strategyId, symbol) => {
    const response = await apiClient.put(`/strategy-symbols/${strategyId}/${normalizeSymbolForUrl(symbol)}/deactivate`);
    return response.data;
  },

  // Update strategy configuration
  updateConfig: async (strategyId, symbol, config) => {
    const response = await apiClient.put(`/strategy-symbols/${strategyId}/${normalizeSymbolForUrl(symbol)}/config`, {
      config
    });
    return response.data;
  },

  // Get all associations for the current user
  getUserAssociations: async (activeOnly = false) => {
    const params = activeOnly ? '?activeOnly=true' : '';
    const response = await apiClient.get(`/strategy-symbols${params}`);
    return response.data;
  },

  // Get symbols for a specific strategy
  getSymbolsForStrategy: async (strategyId) => {
    const response = await apiClient.get(`/strategy-symbols/strategy/${strategyId}`);
    return response.data;
  },

  // Get strategies for a specific symbol
  getStrategiesForSymbol: async (symbol) => {
    const response = await apiClient.get(`/strategy-symbols/symbol/${normalizeSymbolForUrl(symbol)}`);
    return response.data;
  },

  // Get a specific association
  getAssociation: async (strategyId, symbol) => {
    const response = await apiClient.get(`/strategy-symbols/${strategyId}/${normalizeSymbolForUrl(symbol)}`);
    return response.data;
  },

  // Delete an association
  deleteAssociation: async (strategyId, symbol) => {
    const response = await apiClient.delete(`/strategy-symbols/${strategyId}/${normalizeSymbolForUrl(symbol)}`);
    return response.data;
  },

  // Bulk enable all symbols for a strategy
  enableAllForStrategy: async (strategyId, symbols, defaultConfig = {}) => {
    const response = await apiClient.post(`/strategy-symbols/${strategyId}/enable-all`, {
      symbols,
      defaultConfig,
    });
    return response.data;
  },

  // Bulk disable all symbols for a strategy
  disableAllForStrategy: async (strategyId, symbols) => {
    const response = await apiClient.post(`/strategy-symbols/${strategyId}/disable-all`, {
      symbols,
    });
    return response.data;
  }
};

export default strategySymbolApi;